import { LogoStrip } from '../../components/LogoStrip';

const MARQUEE_ITEMS = [
  'Agentic AI',
  'RAG applications',
  'Custom ERP',
  'WhatsApp automation',
  'SOC 2 tooling',
  'Logistics platforms',
  '7+ years international',
  'AWS · DigitalOcean · Railway · Hetzner · PythonAnywhere',
] as const;

function MarqueeGroup({ hidden }: { hidden?: boolean }): React.JSX.Element {
  return (
    <div className="marquee-group" aria-hidden={hidden || undefined}>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item}>{item}</span>
      ))}
    </div>
  );
}

export function Proof(): React.JSX.Element {
  return (
    <>
      <section className="marquee-section" aria-label="What we work on">
        <div className="marquee">
          <div className="marquee-track">
            <MarqueeGroup />
            <MarqueeGroup hidden />
          </div>
        </div>
      </section>
      <section className="proof">
        <div className="container">
          <div className="proof-inner reveal">
            <span className="proof-line">
              <b>7+ years</b> · shipping software internationally
            </span>
            <LogoStrip />
          </div>
        </div>
      </section>
    </>
  );
}
